import {Injectable, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  permissionName: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  permissions_state?: string;
  target?: boolean;
  permissionName: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  nodeName: string;
  permissions: MainMenuItems[];
}

const MENUITEMS = [
    {
      "nodeName": "Dashboard",
      "permissions": [
        {
          "state": "dashboard",
          "permissionName": "Dashboard",
          "type": "link",
          "icon": "ti-home"
        }
          ]
        },
        // {
        //   "nodeName": "Configuration",
        //   "permissions": [
        //     {
        //       "state": "changepassword",
        //       "permissionName": "Change Password",
        //       "type": "link",
        //       "icon": "ti-key"
        // }
        //   ]
        // }

];



@Injectable()
export class MenuItems {

  getAll(): Menu[] {
    return MENUITEMS;
  }

 // private _baseurl = environment.baseURL + 'Permissions/GetAllPermissions';
  private url = 'assets/data/menuitems.json';

  // ngOnInit(): void {
  //   this.getAll();
  // }

  // constructor(private http: HttpClient) {}

  // getAll(): any {
  //   this.http.get(this.url)
  //   .subscribe( data => {
  //       this.data = data;
  //       console.log(data);
  //   });

  // getAll(): Observable<Menu[]> {
  // // const roleId = JSON.parse(localStorage.getItem('employeeDetails')).roleId;
  //   return this.http.get<Menu[]>(this.url);
  // }


}
